angular.module('dnecom')
   .directive('variantCombinationOption', ["$parse", function($parse) {
        return {
            restrict: "E",

            scope: {
                combination: '='
            },

            link: function (scope) {
                scope.style = {};

                if (scope.combination.color) {
                    scope.style = { color: '#' + scope.combination.color };
                }
            },

            template: '<span ng-style="style" ng-bind="combination.name ? combination.name : combination.value"></span>'
        };
    }])
;
